import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMemo } from 'react'

export const publicTransitLineTypes = ['metro', 'rer'] as const

export const useSpaceStations = (
	space: Pick<Space, 'nearest_stations'>,
	lineTypes?: readonly string[],
) => {
	const stations = useMemo(() => {
		return space.nearest_stations?.flatMap((station) => {
			const lines = station?.lines?.reduce(
				(acc, code) => {
					const [type] = code.split('-')

					if (lineTypes && !lineTypes.includes(type)) {
						return acc
					}

					const typeIndex = acc.findIndex((item) => item.type === type)

					if (typeIndex === -1) {
						acc.push({
							lineRefs: [code],
							type,
						})
					} else {
						acc[typeIndex].lineRefs.push(code)
					}

					return acc
				},
				[] as { type: string; lineRefs: string[] }[],
			)

			return lines?.length
				? {
						...station,
						lines,
					}
				: []
		})
	}, [lineTypes, space])

	return { stations }
}
